import React, { Fragment } from 'react';
import { Col, PopoverBody, UncontrolledPopover } from 'reactstrap';
import cn from 'classnames';
import _ from 'lodash';
import Icon from '../Icon/Icon';
import { FMessage } from '../../hoc/IntlComponents';
import StreamTDSHintContent from './StreamTDSHintContent';

const StreamTDSHint = ({flow, flowsInfo, offersInfo, inScripts, scrKey, notFoundOffersInStreams, defaultStreams}) => {
  const getData = () => {
    if(!flowsInfo && !offersInfo && !Object.keys(notFoundOffersInStreams).length) {
      return null;
    }
    const flowObj = _.find([...defaultStreams, ...flowsInfo], { id: flow });
    let offerId = _.get(flowObj, 'offerId') || _.get(flowObj, 'offer_id');
    const offerObj = _.find(offersInfo, { id: offerId });
    const offerTitle = offerObj ? offerObj.title : null;
    let flowLink = flowObj && flowObj.link ? flowObj.link : null;
    if(!flowLink) {
      const defFlow = defaultStreams.find(item => item.id === flow);
      if(defFlow && defFlow.link) {
        flowLink = defFlow.link;
      }
    }
    const flowLandingsSelectedIds = flowObj && flowObj.landings && flowObj.landings.length ?
      _.map(_.filter(flowObj.landings, land => land.selected), land => land.id) : [];
    const flowTransitsSelectedIds = flowObj && flowObj.transits && flowObj.transits.length ?
      _.map(_.filter(flowObj.transits, trans => trans.selected), trans => trans.id) : [];
    return {
      offerId,
      offerTitle,
      flowLink,
      landings: offerObj ? _.filter(offerObj.landings, item => _.includes(flowLandingsSelectedIds, item.id)) : [],
      transits: offerObj ? _.filter(offerObj.transits, item => _.includes(flowTransitsSelectedIds, item.id)) : [],
      flowObjError: flowObj ? false : 'stream.not-found',
      offerObjError: !notFoundOffersInStreams[offerId] ? false : 'offer.not-found',
    };
  };
  const data = getData();
  const { flowObjError, offerObjError } = data;
  const landings = _.get(data, 'landings');
  const transits = _.get(data, 'transits');

  const errorClasses = (defaultClass = '') => cn(defaultClass, {
    error: (!data || flowObjError || offerObjError),
    'no-offer': offerObjError,
  });
  const iconType = (!data || flowObjError || offerObjError) ? 'warning' : 'info';

  const renderBody = () => {
    if(!data) {
      return null;
    } else {
      if(offerObjError) {
        return (
          <div className='not-found'>
            <StreamTDSHintContent
              data={data}
              landings={landings}
              transits={transits}
              offerObjError={offerObjError}
            />
          </div>

        );
      } else if(flowObjError) {
        return (
          <div className='not-found'>
            <Icon type='fire' />
            <FMessage id={`streamTDS.hint.${flowObjError}`}/>
          </div>
        );
      } else {
        return (
          <StreamTDSHintContent
            data={data}
            landings={landings}
            transits={transits}
          />
        );
      }
    }
  };
  return (
    <Col xs='1' className="stream-tds-flow-hint">
      {data &&
        <Fragment>
          <Icon
            id={`stream-tds-flow-hint_${flow}_${inScripts}_${scrKey}`}
            type={iconType}
            className={errorClasses()}
          />
          <UncontrolledPopover
            className={errorClasses('stream-tds-flow-hint-popover')}
            placement="left"
            target={`stream-tds-flow-hint_${flow}_${inScripts}_${scrKey}`}
            placement='right'
            trigger="legacy hover"
          >
            <PopoverBody>
              <div className="stream-tds-flow-hint-popover-body">
                {renderBody()}
              </div>
            </PopoverBody>
          </UncontrolledPopover>
        </Fragment>
      }
    </Col>
  );
};

export default StreamTDSHint;